import * as React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Container, TextField, Typography } from '@mui/material';
import { Sessions } from '../../controllers';
import { CONST, SimpleValidators, TokenValidator } from '../../utils';

const ADMIN_ROLE = 4;

export default function Login() {
    const nav = useNavigate();
    const {Login: context} = useOutletContext();
    const [credentials, setCredentials] = React.useState({user: '', pass: ''});
    const [busy, setBusy] = React.useState(false);
    const [error, setError] = React.useState('');

    const acceptToken = React.useCallback(async token => {
        if (!token || !(await TokenValidator.ValidTokenDate(token))) return false;
        const decoded = await TokenValidator.SimplifyToken(token);
        if ((Number(decoded.roles) & ADMIN_ROLE) !== ADMIN_ROLE) {
            setError('Administrator permission is required.');
            return false;
        }
        context.didLogin(true);
        nav('main', {replace: true});
        return true;
    }, [context, nav]);

    React.useEffect(() => {
        TokenValidator.GetInternalUser().then(acceptToken);
    }, [acceptToken]);

    const submit = async event => {
        event.preventDefault();
        setError('');
        if (!(await SimpleValidators.Email(credentials.user))) {
            setError('Enter a valid email address.');
            return;
        }
        setBusy(true);
        const response = await Sessions.Internal(credentials.user, credentials.pass);
        setBusy(false);
        if (!response || !response.success) {
            setError(response ? response.message : 'Login failed.');
            return;
        }
        const decoded = await TokenValidator.SimplifyToken(response.token);
        if ((Number(decoded.roles) & ADMIN_ROLE) !== ADMIN_ROLE) {
            setError('Administrator permission is required.');
            return;
        }
        localStorage.setItem(CONST.STORAGE_KEYS.INTERNAL_LOGIN, JSON.stringify(response.token));
        await acceptToken(response.token);
    };

    return (
        <Container maxWidth='sm'>
            <Box component='form' onSubmit={submit} sx={{mt: 8, display: 'flex', flexDirection: 'column', gap: 2}}>
                <Typography variant='h5'>FGS Management - Sign in</Typography>
                {error && <Alert severity='error'>{error}</Alert>}
                <TextField required label='Email Address' autoComplete='username' value={credentials.user}
                    onChange={e => setCredentials({...credentials, user: e.target.value})} />
                <TextField required type='password' label='Password' autoComplete='current-password' value={credentials.pass}
                    onChange={e => setCredentials({...credentials, pass: e.target.value})} />
                <Button type='submit' variant='contained' disabled={busy}>{busy ? <CircularProgress size={24} /> : 'Sign In'}</Button>
            </Box>
        </Container>
    );
}
